import React from 'react'
import Projects from "./Projects";
import About from "./About";
import Contact from "./Contact";
import Contents  from "./Contents";
import { AnimatePresence } from "framer-motion";
import {    Routes , Route} from 'react-router-dom'

function main() {
    
 
  return (
    <div>
        <AnimatePresence>
             <Routes  >
                <Route path="/" element={<Contents/>}/>
                <Route path="/projects" element={<Projects />}/>
                <Route path="/about" element={<About />}/>
                <Route path="/contact" element={<Contact />}/>
            </Routes>
        </AnimatePresence>
      
    </div>
  )
}

export default main
